var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOutlineEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Outline/eye"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9983 9.99935C12.9983 11.3801 11.879 12.4993 10.4983 12.4993C9.11762 12.4993 7.99833 11.3801 7.99833 9.99935C7.99833 8.61864 9.11762 7.49935 10.4983 7.49935C11.879 7.49935 12.9983 8.61864 12.9983 9.99935Z",
    stroke: "#344054",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.54688 9.99932C3.60877 6.61841 6.76734 4.16602 10.4987 4.16602C14.2301 4.16602 17.3887 6.61844 18.4505 9.99938C17.3886 13.3803 14.2301 15.8327 10.4987 15.8327C6.76734 15.8327 3.60875 13.3803 2.54688 9.99932Z",
    stroke: "#344054",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOutlineEye);
export default __webpack_public_path__ + "static/media/icon-outline-eye.748ac50b854924330441d500e8c77600.svg";
export { ForwardRef as ReactComponent };